import {useCallback} from 'react'

import type {SystemColumnId} from '../../api/columns/contracts/memex-column'
import {useViews} from '../../hooks/use-views'

type FindLoadedFieldIdsHookReturnType = {
  /**
   * Queries the client-side state to determine which columns have been loaded
   * (i.e. we have column values for)
   * @return A list of column ids which have been loaded
   */
  findLoadedFieldIdsForCurrentView: () => ReadonlyArray<SystemColumnId | number>
}

export const useFindLoadedFieldIdsForCurrentView = (): FindLoadedFieldIdsHookReturnType => {
  const {loadedFieldIdsByViewRef, currentView} = useViews()

  // Get the loaded field ids list for the current view.
  const findLoadedFieldIdsForCurrentView = useCallback(() => {
    return [...(loadedFieldIdsByViewRef.current[currentView?.id ?? -1] ?? [])]
  }, [loadedFieldIdsByViewRef, currentView?.id])

  return {findLoadedFieldIdsForCurrentView}
}
